import { isNullOrUndefined } from 'shared/lib/object/object';
import { userScopeOperator, userScopeType } from 'shared/constants.json';

const copyUserScope = (scope) => {
  if (isNullOrUndefined(scope)) {
    return scope;
  }
  const res = { ...scope };
  delete res.uid;

  if (!isNullOrUndefined(res.timeRange)) {
    delete res.timeRange.uid;
  }
  if (!isNullOrUndefined(res.numberRange)) {
    delete res.numberRange.uid;
  }
  return res;
};

export const copyUserScopeTree = (scopeTree) => {
  if (isNullOrUndefined(scopeTree)) {
    return scopeTree;
  }
  const res = { ...scopeTree };
  delete res.uid;
  if (!isNullOrUndefined(res.scope)) {
    res.scope = copyUserScope(res.scope);
  }
  if (Array.isArray(res.children)) {
    res.children = res.children.map((c) => copyUserScopeTree(c));
  }
  return res;
};

export const makeStaticUserUserScope = (user) => ({ type: userScopeType.staticUsers, staticUsers: [user] });

export const makeUserScopeTree = (account, userScope) => ({
  account,
  op: userScopeOperator.or,
  children: [{
    op: userScopeOperator.and,
    children: [{
      op: userScopeOperator.and,
      scope: userScope,
    }],
  }],
});
